import React from "react";
import "./JumbotronStyles.css";

function JumboSubTitleTwo({ children, ...restProps }) {
  if (typeof children === "string") {
    return (
      <h2
        className="jumbo-subtitletwo"
        {...restProps}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    );
  }

  return (
    <h2 className="jumbo-subtitletwo" {...restProps}>
      {children}
    </h2>
  );
}

export default JumboSubTitleTwo;
